// =============================================================================
// QUOTE LIST COLUMN DEFINITIONS
// =============================================================================

// Column size system (similar to clothing sizes)
export type ColumnSize = "xs" | "s" | "m" | "l" | "xl" | "xxl";

export const COLUMN_SIZES: Record<ColumnSize, string> = {
    xs: "4rem",   // Extra small - short numbers, icons
    s: "6rem",    // Small - dates, short text
    m: "8rem",    // Medium - standard text
    l: "10rem",   // Large - names, longer text
    xl: "12rem",  // Extra large - descriptions
    xxl: "16rem", // Extra extra large - long descriptions
};

export interface QuoteListColumnDefinition {
    field: string;
    header: string;
    sortable: boolean;
    visible: boolean;
    size: ColumnSize;
}

// Helper to get width from size
export function getColumnWidth(size: ColumnSize): string {
    return COLUMN_SIZES[size];
}

const I18N_PREFIX = "QUOTE_LIST.";

export const QUOTE_LIST_COLUMNS: QuoteListColumnDefinition[] = [
    // Columns in fixed order
    { field: "id", header: I18N_PREFIX + "QUOTE_NR", sortable: true, visible: true, size: "s" },
    { field: "customerName", header: I18N_PREFIX + "CUSTOMER", sortable: true, visible: true, size: "m" },
    { field: "contactName", header: I18N_PREFIX + "CONTACTPERSON", sortable: true, visible: false, size: "m" },
    { field: "customerReference", header: I18N_PREFIX + "CUSTOMER_REFERENCE", sortable: true, visible: false, size: "m" },
    { field: "opportunityName", header: I18N_PREFIX + "OPPORTUNITY_NAME", sortable: true, visible: true, size: "m" },
    { field: "versionItemCount", header: I18N_PREFIX + "ROWS", sortable: true, visible: false, size: "xs" },
    { field: "versionItemQuantity", header: I18N_PREFIX + "ARTICLES", sortable: true, visible: false, size: "xs" },
    { field: "versionGrossProfit1", header: I18N_PREFIX + "GROSS_PROFIT", sortable: true, visible: true, size: "m" },
    { field: "versionGrossMargin1", header: I18N_PREFIX + "GROSS_MARGIN", sortable: true, visible: true, size: "s" },
    { field: "versionTotal", header: I18N_PREFIX + "TOTAL", sortable: true, visible: true, size: "m" },
    { field: "created", header: I18N_PREFIX + "CREATED", sortable: true, visible: false, size: "s" },
    { field: "updated", header: I18N_PREFIX + "LAST_CHANGED", sortable: true, visible: false, size: "s" },
    { field: "salesPersonName", header: I18N_PREFIX + "SELLER", sortable: true, visible: true, size: "m" },
    { field: "salesSupportPersonName", header: I18N_PREFIX + "SALES_SUPPORT", sortable: true, visible: false, size: "l" },
    { field: "salesOrderNo", header: I18N_PREFIX + "SALES_ORDER_NO", sortable: true, visible: false, size: "m" },

    // Always second to last
    { field: "status", header: I18N_PREFIX + "STATUS", sortable: true, visible: true, size: "m" },

    // Always last column
    { field: "validTo", header: I18N_PREFIX + "VALID_TO", sortable: true, visible: true, size: "m" },
];

export const DEFAULT_QUOTE_LIST_VISIBLE_COLUMNS: string[] = QUOTE_LIST_COLUMNS
    .filter(col => col.visible)
    .map(col => col.field);

export const ALL_QUOTE_LIST_COLUMNS: string[] = QUOTE_LIST_COLUMNS.map(col => col.field);
